import { render, staticRenderFns } from "./LocationCardText.vue?vue&type=template&id=8ce93efa&"
import script from "./LocationCardText.vue?vue&type=script&lang=js&"
export * from "./LocationCardText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports